import { FC } from "react";
import { Header } from "../parts/Header";

export const LinePage: FC = () => {
  return (
    <div>
      <Header></Header>
      <div className="margin-auto px-4 box-border" style={{ width: '720px', maxWidth: '100%' }}>
        <div className="mt-12 mb-4" style={{ fontSize: '16px', textAlign: 'center' }}>
          初参加のご連絡は以下の公式LINEアカウントからご連絡ください
        </div>
        <div className="mb-24" style={{ textAlign: 'center' }}>
          <a
            href="https://lin.ee/kSB0uAj"
            target="_blank"
            rel="noopener noreferrer"
            className="hover-button"
            aria-label="公式LINEアカウントを開く"
            style={{ display: 'inline-block' }}
          >
            <img
              src="/images/L_gainfriends_2dbarcodes_GW.png"
              alt="CHIROL 公式LINEアカウント QRコード"
              style={{ maxWidth: '280px', width: '100%', height: 'auto', borderRadius: '8px' }}
            />
          </a>
          <div className="mt-4">
            <a href="https://lin.ee/kSB0uAj" target="_blank" rel="noopener noreferrer" className="hover-button" style={{ textDecoration: 'underline' }}>
              https://lin.ee/kSB0uAj
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
